import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationDot, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import styles from '../../styles/usodosolo/UsoDoSolo.module.scss'

type HoverState = 'idle' | 'enter' | 'leave'

type Props = {
  
    onDetailsClick?: (documentos: Record<string, unknown>) => () => void
    onMapCenter: (documentos: Record<string, unknown>) => () => void
    onLocationMouseEnter?: (entidade: Record<string, unknown>) => void
    onLocationMouseLeave?: (entidade: Record<string, unknown>) => void
  dataItem: Record<string, unknown>
}

export const ResultadoValorUsoDoSoloCommandGridCell = ({
    onDetailsClick,
  onMapCenter,
  dataItem,
  onLocationMouseEnter,
  onLocationMouseLeave
}: Props) => {

  const [locationHoverState, setLocationHoverState] =
    useState<HoverState>('idle')

  const handleMouseEnter = () => setLocationHoverState('enter')
  const handleMouseLeave = () => setLocationHoverState('leave')

  useEffect(() => {
    if (locationHoverState === 'enter') {
      onLocationMouseEnter &&  onLocationMouseEnter(dataItem)
    } else if (locationHoverState === 'leave') {
      onLocationMouseLeave && onLocationMouseLeave(dataItem)
    }
  }, [locationHoverState])

  return (
    <td className="k-command-cell" >
      <div className={styles.gridCommand}>
      <div
          role="button"
          className={styles.gridCommandIconButton}
          onClick={onMapCenter(dataItem)}
        >
          <FontAwesomeIcon icon={faLocationDot} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} title="Mostrar no Mapa"/>
        </div> 
        {onDetailsClick? <>
          <div
          role="button"
          className={styles.gridCommandIconButton}
          onClick={onDetailsClick(dataItem)}
        >
          <FontAwesomeIcon icon={faInfoCircle} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} title="Detalhes de registo"/>
        </div> </>:<></>}
             
      </div>
    </td>
  )
}
